<div class="screen-element toast-screen">
	<div class="title" [ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle')}">{{title|uppercase}}</div>
	<div class="dashboard-center">
		<div *ngIf="value" class="value">{{value}}</div>
		<div *ngIf="unit" class="unit">{{unit}}</div>
		<div *ngIf="dashIcon" class="icon {{dashIcon}}"></div>
	</div>
	<div class="text text-1"><text-widget [color]="getColor(1)" [text]="getText(0)"></text-widget></div>
	<div class="text text-2"><text-widget [color]="getColor(2)" [text]="getText(1)"></text-widget></div>
	<div class="text text-3"><text-widget [color]="getColor(3)" [text]="getText(2)"></text-widget></div>
	<!--
	<div class="text text-1">{{menuService.getText(0)}}</div>
	<div class="text text-2">{{menuService.getText(1)}}</div>
	<div *ngIf="!menuService.hasParameter('yes-no-button')" class="text text-3">{{menuService.getText(2)}}</div>
	<div *ngIf="menuService.hasParameter('yes-no-button')" class="text text-3">
		<span class="inline-icon iconBack vaillant-grey-50">&nbsp;</span><span class="vaillant-grey-50">Nein</span>&nbsp;
		<span class="inline-icon iconCheckConfirm vaillant-grey-50">&nbsp;</span><span class="vaillant-grey-50">Ja</span>
	</div>
	-->
</div>